var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { Dialog, Box, Grid, Typography, DialogContent, Badge, Snackbar, Alert } from "@mui/material";
import { Cancel as CancelIcon } from "@mui/icons-material";
import { INVENTORY_MANAGEMENT_SHOPIFY, INVENTORY_POLICY_DENY, PaymentTermType, TOASTER_TIMEOUT } from "./Constant";
import { getCountries } from "country-state-picker";
import { useTranslation } from "react-i18next";
import store from "../reduxStore/store";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";
import { State } from "country-state-city";
// --- Shared helpers (non-React) ---
export var clampCustomItemQty = function (n) {
    if (!Number.isFinite(n))
        return 1;
    return Math.max(1, Math.floor(n));
};
export var normalizeCustomItemNumberInput = function (value) {
    // Allow empty while typing, but submit will coerce to 0.00 / "" as needed.
    var trimmed = (value !== null && value !== void 0 ? value : "").toString().trim();
    if (trimmed === "")
        return "";
    // Keep only one dot; allow digits
    var cleaned = trimmed.replace(/[^\d.]/g, "");
    var parts = cleaned.split(".");
    var normalized = parts.length <= 1 ? parts[0] : "".concat(parts[0], ".").concat(parts.slice(1).join(""));
    return normalized;
};
/** Format a date as "yyyy-MM-dd" for API payloads (e.g. payment terms issueDateInput/dueDateInput). Returns null if invalid. */
export var formatDateForServer = function (date) {
    try {
        if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
            return null;
        }
        var year = date.getFullYear();
        var month = (date.getMonth() + 1).toString().padStart(2, "0");
        var day = date.getDate().toString().padStart(2, "0");
        return "".concat(year, "-").concat(month, "-").concat(day);
    }
    catch (_a) {
        return null;
    }
};
/** Normalize payment term type to uppercase (e.g. "fixed" -> "FIXED") for consistent comparison. Use wherever payment terms type is set or compared. */
export var normalizePaymentTermType = function (value) {
    if (value == null || String(value).trim() === "")
        return null;
    return String(value).trim().toUpperCase();
};
/** Parse dueInDays from API (backend PaymentTerms.dueInDays is string). Empty string is not coerced – treated as missing so Net terms don't get wrong values. Use wherever dueInDays is read from API or payment terms. */
export var parseDueInDaysFromApi = function (value) {
    if (value === undefined || value === null)
        return undefined;
    var s = String(value).trim();
    return s === "" ? undefined : Number(s);
};
/**
 * Format payment terms due date for display across all order types (Draft, YourSales, Pending, etc.).
 */
var formatDateMMddyyyy = function (date) {
    var month = (date.getMonth() + 1).toString().padStart(2, "0");
    var day = date.getDate().toString().padStart(2, "0");
    var year = date.getFullYear();
    return "".concat(month, "/").concat(day, "/").concat(year);
};
function toValidLocalDate(year, month, day) {
    if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) {
        return null;
    }
    var parsed = new Date(year, month - 1, day);
    if (parsed.getFullYear() !== year || parsed.getMonth() !== month - 1 || parsed.getDate() !== day) {
        return null;
    }
    return parsed;
}
/** Parses API/display date strings (dd-MM-yyyy, yyyy-MM-dd, ISO, MM/dd/yyyy, /Date(ms)/). */
export var parseDisplayDateValue = function (raw) {
    if (raw == null) {
        return null;
    }
    if (raw instanceof Date) {
        return Number.isNaN(raw.getTime()) ? null : raw;
    }
    var value = String(raw).trim();
    if (value === "" || value === "-" || value.toLowerCase() === "null" || value.startsWith("0001-01-01")) {
        return null;
    }
    try {
        if (value.includes("/Date(")) {
            var ms = parseInt(value.replace("/Date(", "").replace(")/", ""), 10);
            if (!Number.isNaN(ms)) {
                var parsed = new Date(ms);
                return Number.isNaN(parsed.getTime()) ? null : parsed;
            }
        }
        var dateToken = value.split(/\s+/)[0].split("T")[0];
        var hyphenParts = dateToken.split("-");
        if (hyphenParts.length === 3) {
            var a = parseInt(hyphenParts[0], 10);
            var b = parseInt(hyphenParts[1], 10);
            var c = parseInt(hyphenParts[2], 10);
            if (Number.isFinite(a) && Number.isFinite(b) && Number.isFinite(c)) {
                if (hyphenParts[0].length === 4) {
                    return toValidLocalDate(a, b, c);
                }
                if (hyphenParts[2].length === 4) {
                    return toValidLocalDate(c, b, a);
                }
            }
        }
        var slashParts = dateToken.split("/");
        if (slashParts.length === 3) {
            var p0 = parseInt(slashParts[0], 10);
            var p1 = parseInt(slashParts[1], 10);
            var p2 = parseInt(slashParts[2], 10);
            if (Number.isFinite(p0) && Number.isFinite(p1) && Number.isFinite(p2) && slashParts[2].length >= 4) {
                if (p0 > 12) {
                    return toValidLocalDate(p2, p1, p0);
                }
                return toValidLocalDate(p2, p0, p1);
            }
        }
        var fallback = new Date(value);
        return Number.isNaN(fallback.getTime()) ? null : fallback;
    }
    catch (_a) {
        return null;
    }
};
/** Table/export display (`MM/dd/yyyy`) — same format as payment terms helpers. */
export var formatDisplayDateValue = function (raw) {
    try {
        var parsed = parseDisplayDateValue(raw);
        return parsed ? formatDateMMddyyyy(parsed) : "";
    }
    catch (_a) {
        return "";
    }
};
export var formatDueDate = function (dueDate, paymentTermType, dueInDays) {
    try {
        if (!dueDate) {
            var pt = (paymentTermType || "").toLowerCase().replace(/\s+/g, "_");
            if (pt === PaymentTermType.RECEIPT.toLocaleLowerCase()) {
                return "Due on receipt";
            }
            if (pt === PaymentTermType.FULFILLMENT.toLocaleLowerCase()) {
                return "Due on Fulfillment";
            }
            return "-";
        }
        var date = typeof dueDate === "string" ? new Date(dueDate) : dueDate;
        if (isNaN(date.getTime())) {
            return "-";
        }
        var formattedDate = formatDateMMddyyyy(date);
        if ((paymentTermType || "").toLowerCase().replace(/\s+/g, "_") === PaymentTermType.NET.toLowerCase() && dueInDays != null) {
            return "".concat(formattedDate);
        }
        return formattedDate;
    }
    catch (_a) {
        return "-";
    }
};
/**
 * Format payment terms issue date for display. Issue date is only relevant for Fixed and Net types.
 * For Receipt and Fulfillment there is no issue date — returns "-".
 */
export var formatIssueDate = function (issueDate, paymentTermType) {
    try {
        var pt = (paymentTermType || "").toLowerCase().replace(/\s+/g, "_");
        if (pt === PaymentTermType.RECEIPT.toLowerCase() || pt === PaymentTermType.FULFILLMENT.toLowerCase()) {
            return "-";
        }
        if (!issueDate)
            return "-";
        var date = typeof issueDate === "string" ? new Date(issueDate) : issueDate;
        if (isNaN(date.getTime()))
            return "-";
        return formatDateMMddyyyy(date);
    }
    catch (_a) {
        return "-";
    }
};
/**
 * Format any date value for display (e.g. order date, paid date). Uses locale date string; returns "-" for null/invalid.
 */
export var formatOrderDate = function (dateVal) {
    try {
        if (!dateVal)
            return "-";
        var d = typeof dateVal === "string" ? new Date(dateVal) : dateVal;
        if (isNaN(d.getTime()))
            return "-";
        return d.toLocaleDateString();
    }
    catch (_a) {
        return "-";
    }
};
export var getDisplayPaymentTermsData = function (fromDisplay, fromOrder) {
    var _a, _b, _c, _d, _e;
    if (!fromDisplay && !fromOrder)
        return null;
    var type = (_a = fromDisplay === null || fromDisplay === void 0 ? void 0 : fromDisplay.paymentTermType) !== null && _a !== void 0 ? _a : fromOrder === null || fromOrder === void 0 ? void 0 : fromOrder.paymentTermsType;
    var dueInDays = (_b = fromDisplay === null || fromDisplay === void 0 ? void 0 : fromDisplay.dueInDays) !== null && _b !== void 0 ? _b : ((fromOrder === null || fromOrder === void 0 ? void 0 : fromOrder.dueInDays) != null ? Number(fromOrder.dueInDays) : undefined);
    var id = (_c = fromDisplay === null || fromDisplay === void 0 ? void 0 : fromDisplay.paymentTermsTemplateId) !== null && _c !== void 0 ? _c : fromOrder === null || fromOrder === void 0 ? void 0 : fromOrder.id;
    var issueDate = (_d = fromDisplay === null || fromDisplay === void 0 ? void 0 : fromDisplay.issueDate) !== null && _d !== void 0 ? _d : fromOrder === null || fromOrder === void 0 ? void 0 : fromOrder.issueDate;
    var dueDate = (_e = fromDisplay === null || fromDisplay === void 0 ? void 0 : fromDisplay.dueDate) !== null && _e !== void 0 ? _e : fromOrder === null || fromOrder === void 0 ? void 0 : fromOrder.dueDate;
    return {
        paymentTermType: type,
        dueInDays: dueInDays,
        id: id,
        paymentTermsTemplateId: id,
        name: fromOrder === null || fromOrder === void 0 ? void 0 : fromOrder.name,
        translatedName: fromOrder === null || fromOrder === void 0 ? void 0 : fromOrder.translatedName,
        issueDate: issueDate,
        dueDate: dueDate,
    };
};
export var formatIssueDateFromObject = function (paymentTerms) {
    var _a;
    if (!paymentTerms)
        return "-";
    var ptType = (_a = paymentTerms.paymentTermType) !== null && _a !== void 0 ? _a : paymentTerms.paymentTermsType;
    return formatIssueDate(paymentTerms.issueDate, ptType);
};
export var formatDueDateFromObject = function (paymentTerms) {
    var _a;
    if (!paymentTerms)
        return "-";
    var ptType = (_a = paymentTerms.paymentTermType) !== null && _a !== void 0 ? _a : paymentTerms.paymentTermsType;
    var rawDue = paymentTerms.dueInDays;
    var dueInDays = rawDue !== undefined && rawDue !== null ? (typeof rawDue === "number" ? rawDue : Number(rawDue)) : undefined;
    return formatDueDate(paymentTerms.dueDate, ptType, dueInDays);
};
export var getPaymentTermsDescription = function (paymentTerms) {
    var _a, _b, _c, _d, _e, _f, _g;
    try {
        if (!paymentTerms)
            return "-";
        var ptType = (_b = ((_a = paymentTerms.paymentTermType) !== null && _a !== void 0 ? _a : paymentTerms.paymentTermsType)) === null || _b === void 0 ? void 0 : _b.toLowerCase().replace(/\s+/g, "_");
        var rawDue = paymentTerms.dueInDays;
        var ptDueInDays = rawDue !== undefined && rawDue !== null ? (typeof rawDue === "number" ? rawDue : Number(rawDue)) : undefined;
        var ptTemplateId_1 = (_c = paymentTerms.paymentTermsTemplateId) !== null && _c !== void 0 ? _c : paymentTerms.id;
        if (ptType === PaymentTermType.RECEIPT.toLocaleLowerCase())
            return "Due on receipt";
        if (ptType === PaymentTermType.FULFILLMENT.toLowerCase())
            return "Due on fulfillment";
        if (ptType === PaymentTermType.NET.toLowerCase() && ptDueInDays != null)
            return "Within ".concat(ptDueInDays, " days");
        if (ptType === PaymentTermType.FIXED.toLowerCase())
            return "Fixed date";
        var paymentTermsTemplates = Array.isArray((_e = (_d = store.getState().salesRepData) === null || _d === void 0 ? void 0 : _d.baseData) === null || _e === void 0 ? void 0 : _e.PaymentTermsTemplates)
            ? (_g = (_f = store.getState().salesRepData) === null || _f === void 0 ? void 0 : _f.baseData) === null || _g === void 0 ? void 0 : _g.PaymentTermsTemplates
            : [];
        if (ptTemplateId_1 && paymentTermsTemplates.length > 0) {
            var template = paymentTermsTemplates.find(function (tpl) { return tpl.id === ptTemplateId_1; });
            if (template === null || template === void 0 ? void 0 : template.description)
                return template.description;
        }
        if (paymentTerms.translatedName)
            return paymentTerms.translatedName;
        if (paymentTerms.name)
            return paymentTerms.name;
        return "-";
    }
    catch (_h) {
        return "-";
    }
};
// Helper function to determine discount type from value_type (always check value_type first)
export var getDiscountTypeFromValueType = function (appliedDiscount) {
    var _a;
    try {
        if (!appliedDiscount)
            return "percentage";
        var valueType = ((_a = appliedDiscount.value_type) !== null && _a !== void 0 ? _a : "").toLowerCase();
        // Check explicit types - if value_type is "percentage", it's percentage
        if (valueType === "percentage")
            return "percentage";
        // Check for dollar/fixed types
        if (valueType === "fixed" || valueType === "dollar" || valueType === "amount" || valueType === "fixed_amount") {
            return "dollar";
        }
        // Default to percentage if value_type is missing or unknown
        return "percentage";
    }
    catch (error) {
        // Default to percentage on any error
        return "percentage";
    }
};
export function SharedFunctions() {
    var _this = this;
    var _a, _b, _c;
    var _d = useState({}), copyIconSuccessColor = _d[0], setCopyIconSuccessColor = _d[1];
    var _e = useState(false), productTableGuidePopup = _e[0], setProductTableGuidePopup = _e[1];
    var _f = useState(true), imgLoading = _f[0], setImgLoading = _f[1];
    var t = useTranslation().t;
    var loggedInRepData = (_c = (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.loggedInRepDetails) === null || _b === void 0 ? void 0 : _b.countriesAndStates) !== null && _c !== void 0 ? _c : {};
    var copyTextFunction = function (text, key) { return __awaiter(_this, void 0, void 0, function () {
        var textTobeCopied, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    textTobeCopied = text;
                    if (!textTobeCopied) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.clipboard.writeText(textTobeCopied)];
                case 2:
                    _b.sent();
                    setCopyIconSuccessColor(__assign(__assign({}, copyIconSuccessColor), (_a = {}, _a[key] = "#05bf05", _a)));
                    setTimeout(function () {
                        var _a;
                        setCopyIconSuccessColor(__assign(__assign({}, copyIconSuccessColor), (_a = {}, _a[key] = "#757575", _a)));
                    }, 2000);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    return [2 /*return*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleProductTableGuidePopup = function () {
        setProductTableGuidePopup(!productTableGuidePopup);
    };
    var handleImageLoad = function () {
        setImgLoading(false);
    };
    var handleImageError = function () {
        setImgLoading(false);
    };
    var getProductTableRenderPopup = (_jsx(Dialog, __assign({ open: productTableGuidePopup, onClose: function () { return setProductTableGuidePopup(false); }, maxWidth: "sm", fullWidth: true }, { children: _jsxs(Box, __assign({ className: "ST_DB_Dialog_Box" }, { children: [_jsxs(Grid, __assign({ container: true, spacing: 2, mb: 2, pl: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 10, md: 10 }, { children: _jsx(Typography, __assign({ variant: "h6" }, { children: _jsx("b", { children: t("productStatus") }) })) })), _jsx(Grid, __assign({ item: true, xs: 2, md: 2, sx: { textAlign: "right" }, pr: 1 }, { children: _jsx(CancelIcon, { className: "ST_Cursor_Pointer", onClick: function () {
                                    setProductTableGuidePopup(false);
                                } }) }))] })), _jsx("hr", { className: "ST_DB_Hr" }), imgLoading && _jsx("p", __assign({ style: { textAlign: "center" } }, { children: t("loading") })), _jsx(DialogContent, __assign({ sx: { padding: "0px" } }, { children: _jsx("img", { style: { width: "100%", height: "100%" }, src: "https://salesrepapp.azurewebsites.net/assets/img/productTableGuide.png", onLoad: handleImageLoad, onError: handleImageError }) })), _jsx("div", __assign({ style: { textAlign: "center", marginTop: "1rem" } }, { children: _jsxs(Typography, __assign({ variant: "h6" }, { children: [t("makeSureInShopify"), " ", _jsx("b", { children: t("products") }), " ", t("sectionTheProductStatusIs"), " ", _jsx("b", { children: t("active") })] })) }))] })) })));
    var checkVariantIsSoldOut = function (variant) {
        var _a, _b, _c;
        // Use same sources as display: inventory_quantity, inventoryQuantity, or quantityAvailable (GraphQL). Parse string from API.
        var raw = (_c = (_b = (_a = variant === null || variant === void 0 ? void 0 : variant.inventory_quantity) !== null && _a !== void 0 ? _a : variant === null || variant === void 0 ? void 0 : variant.inventoryQuantity) !== null && _b !== void 0 ? _b : variant === null || variant === void 0 ? void 0 : variant.quantityAvailable) !== null && _c !== void 0 ? _c : 0;
        var variantInventoryQuantity = typeof raw === "string" ? parseInt(raw, 10) : Number(raw);
        var qty = Number.isNaN(variantInventoryQuantity) ? 0 : variantInventoryQuantity;
        return (variant === null || variant === void 0 ? void 0 : variant.inventory_management) === INVENTORY_MANAGEMENT_SHOPIFY && (variant === null || variant === void 0 ? void 0 : variant.inventory_policy) === INVENTORY_POLICY_DENY && qty <= 0;
    };
    var checkAllVariantsSoldOutInProduct = function (product) {
        var _a, _b;
        var isDisabled = false;
        if (((_a = product === null || product === void 0 ? void 0 : product.variants) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            isDisabled = (_b = product === null || product === void 0 ? void 0 : product.variants) === null || _b === void 0 ? void 0 : _b.every(function (variant) { return checkVariantIsSoldOut(variant); });
        }
        else {
            isDisabled = true;
        }
        return isDisabled;
    };
    var filterVariantsWithOutSoldOut = function (product) {
        var _a, _b;
        var productData = __assign({}, product);
        if (((_a = product === null || product === void 0 ? void 0 : product.variants) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            productData["variants"] = (_b = productData === null || productData === void 0 ? void 0 : productData.variants) === null || _b === void 0 ? void 0 : _b.filter(function (variant) { return !checkVariantIsSoldOut(variant); });
        }
        return productData;
    };
    var showInventoryQuantity = function (variant, newProductTable) {
        return newProductTable ? ((variant === null || variant === void 0 ? void 0 : variant.quantityAvailable) || 0) : checkVariantIsSoldOut(variant) ? (_jsx(Badge, { className: "ST_SoldOut", badgeContent: t("soldOut"), color: "warning" })) : (variant === null || variant === void 0 ? void 0 : variant.inventory_management) !== INVENTORY_MANAGEMENT_SHOPIFY ? (t("InventoryNotTracked")) : ((variant === null || variant === void 0 ? void 0 : variant.inventory_quantity) || 0);
    };
    var filterprovince = function (stateArray, countryCode) {
        var countryState_Array = stateArray !== null && stateArray !== void 0 ? stateArray : [];
        if ((countryCode === null || countryCode === void 0 ? void 0 : countryCode.trim()) === "mx") {
            countryState_Array = stateArray === null || stateArray === void 0 ? void 0 : stateArray.map(function (state) { return state === null || state === void 0 ? void 0 : state.replace(/Estado de |Coahuila de|-Llave|de Ocampo/g, ""); });
        }
        return countryState_Array;
    };
    var getCountriesList = function () {
        var _a;
        var countryCodeList = [];
        (_a = getCountries()) === null || _a === void 0 ? void 0 : _a.forEach(function (country) {
            var _a, _b, _c, _d;
            if (((_b = (_a = country === null || country === void 0 ? void 0 : country.code) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === "gb") {
                countryCodeList.push(__assign(__assign({}, country), { name: "United Kingdom" }));
            }
            else if (((_d = (_c = country === null || country === void 0 ? void 0 : country.code) === null || _c === void 0 ? void 0 : _c.trim()) === null || _d === void 0 ? void 0 : _d.toLowerCase()) === "us") {
                countryCodeList.push(__assign(__assign({}, country), { name: "United States" }));
            }
            else {
                countryCodeList.push(country);
            }
        });
        return countryCodeList.sort(function (a, b) { return a.name.localeCompare(b.name); });
    };
    var getProvinceOfShopify = function (CountryName) {
        return loggedInRepData[CountryName] || [];
    };
    var SnackbarAlertMsg = function (alertObject, handleAlertMsgCloseMethod) {
        var _a;
        return (alertObject === null || alertObject === void 0 ? void 0 : alertObject.msg) !== "" ? (_jsx(Snackbar, __assign({ anchorOrigin: { vertical: "bottom", horizontal: "center" }, open: alertObject === null || alertObject === void 0 ? void 0 : alertObject.open, autoHideDuration: TOASTER_TIMEOUT, onClose: handleAlertMsgCloseMethod }, { children: _jsx(Alert, __assign({ onClose: handleAlertMsgCloseMethod, severity: (_a = alertObject === null || alertObject === void 0 ? void 0 : alertObject.severity) !== null && _a !== void 0 ? _a : "error", variant: "filled", sx: { width: "100%" } }, { children: alertObject === null || alertObject === void 0 ? void 0 : alertObject.msg })) }))) : (_jsx(_Fragment, {}));
    };
    var useInfiniteScroll = function (rowsPerPage, setRowsPerPage, Products) {
        var innerScrollRef = useRef(null);
        useEffect(function () {
            var handleScroll = function () {
                var scrollableDiv = innerScrollRef === null || innerScrollRef === void 0 ? void 0 : innerScrollRef.current;
                if (scrollableDiv) {
                    var scrollTop = scrollableDiv === null || scrollableDiv === void 0 ? void 0 : scrollableDiv.scrollTop;
                    var scrollHeight = scrollableDiv === null || scrollableDiv === void 0 ? void 0 : scrollableDiv.scrollHeight;
                    var clientHeight = scrollableDiv === null || scrollableDiv === void 0 ? void 0 : scrollableDiv.clientHeight;
                    var scrollPercent = (scrollTop / (scrollHeight - clientHeight)) * 100;
                    // Load more data when user scrolls to the bottom 10% or top 10% of the div
                    if ((scrollPercent > 90 || scrollTop === 0) && rowsPerPage < (Products === null || Products === void 0 ? void 0 : Products.length)) {
                        var newRowsPerPage = rowsPerPage + 5;
                        setRowsPerPage(newRowsPerPage);
                    }
                }
            };
            var scrollableDiv = innerScrollRef.current;
            if (scrollableDiv) {
                scrollableDiv.addEventListener("scroll", handleScroll);
            }
            return function () {
                if (scrollableDiv) {
                    scrollableDiv.removeEventListener("scroll", handleScroll);
                }
            };
        }, [Products, rowsPerPage]);
        return innerScrollRef;
    };
    var getDateFormat = function (date) {
        var formatted = formatDisplayDateValue(date);
        return formatted || "-";
    };
    var disableTableRow = function (product) {
        var _a, _b;
        return ((_a = product === null || product === void 0 ? void 0 : product.variants) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (_b = product === null || product === void 0 ? void 0 : product.variants) === null || _b === void 0 ? void 0 : _b.every(function (variant) { return !(variant === null || variant === void 0 ? void 0 : variant.availableForSale); }) : false;
    };
    function debounce(func, wait) {
        var timeout;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            clearTimeout(timeout);
            timeout = setTimeout(function () { return func.apply(void 0, args); }, wait);
        };
    }
    function LinearDeterminate() {
        var _a = React.useState(0), progress = _a[0], setProgress = _a[1];
        React.useEffect(function () {
            var timer = setInterval(function () {
                setProgress(function (oldProgress) {
                    if (oldProgress === 100) {
                        return 0;
                    }
                    var diff = Math.random() * 10;
                    return Math.min(oldProgress + diff, 100);
                });
            }, 500);
            return function () {
                clearInterval(timer);
            };
        }, []);
        return (_jsx(Box, __assign({ sx: { width: "100%" } }, { children: _jsx(LinearProgress, { variant: "determinate", value: progress }) })));
    }
    function CircularProgressWithLabel(props) {
        return (_jsxs(Box, __assign({ sx: { position: "relative", display: "inline-flex" } }, { children: [_jsx(CircularProgress, __assign({ variant: "determinate" }, props, { size: 60 })), _jsx(Box, __assign({ sx: {
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        position: "absolute",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    } }, { children: _jsx(Typography, __assign({ variant: "caption", component: "div", sx: { color: "text.secondary" } }, { children: "".concat(Math.round(props.value), "%") })) }))] })));
    }
    function CircularWithValueLabel() {
        var _a = React.useState(10), progress = _a[0], setProgress = _a[1];
        React.useEffect(function () {
            var timer = setInterval(function () {
                setProgress(function (prevProgress) { return (prevProgress >= 100 ? 0 : prevProgress + 10); });
            }, 800);
            return function () {
                clearInterval(timer);
            };
        }, []);
        return _jsx(CircularProgressWithLabel, { value: progress });
    }
    var getZoneCode = function (countryCode, stateName) {
        var _a;
        if (countryCode && stateName) {
            var states = State === null || State === void 0 ? void 0 : State.getStatesOfCountry(countryCode === null || countryCode === void 0 ? void 0 : countryCode.toUpperCase());
            var matched = states === null || states === void 0 ? void 0 : states.find(function (state) { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (stateName === null || stateName === void 0 ? void 0 : stateName.toLowerCase()); });
            return ((_a = matched === null || matched === void 0 ? void 0 : matched.isoCode) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || "";
        }
        else {
            return "";
        }
    };
    // This method is used to normalize and format product and variant names for display.
    // It ensures the default variant is not shown and avoids redundant or empty values,
    var deriveProductAndVariantNames = function (productTitle, variantTitle) {
        var _a, _b;
        try {
            var normalizedProduct = (_a = (productTitle !== null && productTitle !== void 0 ? productTitle : "")) === null || _a === void 0 ? void 0 : _a.trim();
            var normalizedVariantRaw = (_b = (variantTitle !== null && variantTitle !== void 0 ? variantTitle : "")) === null || _b === void 0 ? void 0 : _b.trim();
            var variantIsDefault = (normalizedVariantRaw === null || normalizedVariantRaw === void 0 ? void 0 : normalizedVariantRaw.length) === 0 || (normalizedVariantRaw === null || normalizedVariantRaw === void 0 ? void 0 : normalizedVariantRaw.toLowerCase()) === "default title";
            var resolvedProductName = normalizedProduct || normalizedVariantRaw;
            if (variantIsDefault) {
                return {
                    productName: resolvedProductName,
                    variantName: "",
                };
            }
            if (!resolvedProductName) {
                return {
                    productName: normalizedVariantRaw,
                    variantName: "",
                };
            }
            var shouldShowVariant = (resolvedProductName === null || resolvedProductName === void 0 ? void 0 : resolvedProductName.toLowerCase()) !== (normalizedVariantRaw === null || normalizedVariantRaw === void 0 ? void 0 : normalizedVariantRaw.toLowerCase());
            return {
                productName: resolvedProductName,
                variantName: shouldShowVariant ? normalizedVariantRaw : "",
            };
        }
        catch (error) {
            return {
                productName: "",
                variantName: "",
            };
        }
    };
    return {
        copyTextFunction: copyTextFunction,
        copyIconSuccessColor: copyIconSuccessColor,
        getProductTableRenderPopup: getProductTableRenderPopup,
        handleProductTableGuidePopup: handleProductTableGuidePopup,
        checkVariantIsSoldOut: checkVariantIsSoldOut,
        checkAllVariantsSoldOutInProduct: checkAllVariantsSoldOutInProduct,
        filterVariantsWithOutSoldOut: filterVariantsWithOutSoldOut,
        showInventoryQuantity: showInventoryQuantity,
        filterprovince: filterprovince,
        getProvinceOfShopify: getProvinceOfShopify,
        SnackbarAlertMsg: SnackbarAlertMsg,
        getCountriesList: getCountriesList,
        useInfiniteScroll: useInfiniteScroll,
        getDateFormat: getDateFormat,
        disableTableRow: disableTableRow,
        debounce: debounce,
        LinearDeterminate: LinearDeterminate,
        CircularWithValueLabel: CircularWithValueLabel,
        getZoneCode: getZoneCode,
        deriveProductAndVariantNames: deriveProductAndVariantNames,
    };
}
